import React, { useEffect, useState } from "react";
import "../assets/css/style.css";
import Header from "../Components/Header/HeaderNew";
import ContactUs from "../Components/ContactUs/ContactUs";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";
import { BsChevronDown } from "react-icons/bs";
import { Form, Spinner, Button, Modal } from "react-bootstrap";

import StockdaleImage from "../../src/assets/images/stockdale/stockdaleCC.jpg";
import OlivasLogo from "../../src/assets/images/stockdale/stockdalefittingdaylogo.png";

import axios from "axios";
import { API_URL } from "../Api/config";
import { IoClose } from "react-icons/io5";

function Stockdale() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formId, setFormId] = useState("stockdale");
    const [validated, setValidated] = useState(false);
    const [fName, setFName] = useState("");
    const [lName, setLName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [dexterity, setDexterity] = useState("");
    const [preferredTime, setPreferredTime] = useState("");
    const [description, setDescription] = useState("");
    const [apicall, setApicall] = useState(false);
    const [serverSideError, setServerSideError] = useState(null);

    const timeArray = ["Morning", "Afternoon", "Evening"];
    const dexterityArray = ["Left", "Right"];

    const [width, setWidth] = useState(
        typeof window !== "undefined" ? window.innerWidth : 1024
    );

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []); // <-- empty deps so listener added once

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setValidated(false); // 🔹 reset validation state when modal closes
    };

    const handleShow = () => setShow(true);


    const handleSubmit = async (event) => {
        event.preventDefault();

        // event.currentTarget is the form element when using react-bootstrap Form
        const form = event.currentTarget;

        // Run native HTML5 validation
        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            return;
        }

        // Form is valid — proceed
        setValidated(true);
        setApicall(true);
        setServerSideError(null);

        // Convert dexterity / preferredTime (they are strings from select) to numbers for indexing
        const dexIndex = dexterity === "" ? null : parseInt(dexterity, 10);
        const timeIndex = preferredTime === "" ? null : parseInt(preferredTime, 10);

        const data = {
            firstName: fName,
            lastName: lName,
            phoneNumber: phone,
            email: email,
            description: description,
            preferredtime: timeIndex != null ? timeArray[timeIndex] : "",
            dexterity: dexIndex != null ? dexterityArray[dexIndex] : "",
            subject: "stockdale",
            formid: formId,
        };

        try {
            const response = await fetch(API_URL + "contact/submit-event", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            let result = await response.json();
            if (result.status) {
                // reset form fields
                setFName("");
                setLName("");
                setPhone("");
                setEmail("");
                setDescription("");
                setDexterity("");
                setPreferredTime("");

                // reset validation + errors
                setValidated(false);
                setServerSideError(null);

                setShow(true);
            }
            else {
                setServerSideError(result.message);
            }
        } catch (error) {
            console.error("submit error", error);
            setServerSideError(
                error?.message || "An error occurred. Please try again."
            );
        } finally {
            setApicall(false);
            // Keep validated true so validation UI persists until user fixes
        }
    };



    return (
        <>
            <Helmet>
                <title>Foreward Golf</title>
                <meta
                    name="description"
                    content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen."
                />
                <link rel="canonical" href="https://foreward.golf/about-us" />
                <meta property="og:url" content="https://foreward.golf/about-us" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="About Us" />
                <meta
                    property="og:description"
                    content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen."
                />
                <meta
                    property="og:image"
                    content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`}
                />

                <meta name="twitter:card" content="summary_large_image" />
                <meta property="twitter:domain" content="foreward.golf" />
                <meta property="twitter:url" content="https://foreward.golf/about-us" />
                <meta name="twitter:title" content="About Us" />
                <meta
                    name="twitter:description"
                    content="When it comes to equipment we are completely brand agnostic. With the golf swing we believe there are many ways to get it done. We are golfers, not salesmen."
                />
                <meta
                    name="twitter:image"
                    content={`${process.env.REACT_APP_SITE_URL}logo_icon.png`}
                />
            </Helmet>
            <Header />

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <div className="custom-modal-header">
                        <div className="logo-modal">
                            <img src={require('../../src/assets/images/logo_text.png')} alt="logo" />
                        </div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleClose} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className='modal-image'>
                        <img src={require('../../src/assets/images/forewardFormSubmit.png')} alt="logo" />
                    </div>
                    <h3 className="text-center mb-4">
                        Your message is sent!
                    </h3>
                    <p className="text-center mb-0">
                        Our staff will be in contact shortly to answer any questions and get you sorted.
                    </p>
                </Modal.Body>
            </Modal>
            <section id="hero" className="hero img_bg page-section">
                <div className="iframe-hero">
                    <img
                        src={StockdaleImage}
                        alt=""
                        className="img-fluid custom-page-img"
                    />
                </div>

                <div className="container-xl">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hero_content d-flex align-items-center justify-content-center">
                                <img src={OlivasLogo} alt="" />
                            </div>
                            <div className="arrow_animation show_mobile bounce pt-3">
                                <i className="bi bi-arrow-down-short" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="our_process" className="our_process bg_dark page-section bg_img pb-0">
                <div className="container-xl d-flex align-items-center justify-content-center overflow-visible-container">
                    <div className="col-12 col-md-12 col-lg-8 col-xl-6 pr_card card-radius card-dark bg_dark_black">
                        <div className="pr_content1 mb-0 mt-2">
                            <div className="pr_content1 mb-0 mt-2">
                                <div className=" ">
                                    <div className="form-element-event-list mb-5 mt-5">
                                        <h2 style={{ "color": "rgb(255, 255, 255)", "font-weight": "bold" }}>Location:</h2>
                                        <p style={{ "color": "rgb(255, 255, 255)" }}>Stockdale Country Club</p>
                                        <h2 style={{ "color": "rgb(255, 255, 255)" }}>Address:</h2>
                                        <p style={{ "color": "rgb(255, 255, 255)" }}>7001 Stockdale Highway<br />Bakersfield, CA 93309-1313</p>
                                        <h2 style={{ "color": "rgb(255, 255, 255)" }}>When:</h2>
                                        <p style={{ "color": "rgb(255, 255, 255)" }}>November 23rd<br /> 8am to 5pm</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <div className="row gx-2">
                                <Form.Group className="col-md-6 form-group" controlId="validationCustom01">
                                    <input
                                        type="text"
                                        name="f-name"
                                        className="form-control dashboard-input-box-3"
                                        placeholder="First name"
                                        value={fName}
                                        onChange={(e) => setFName(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a first name.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-6 form-group" controlId="validationCustom02">
                                    <input
                                        type="text"
                                        name="l-name"
                                        className="form-control dashboard-input-box-3"
                                        placeholder="Last name"
                                        value={lName}
                                        onChange={(e) => setLName(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a last name.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-12 form-group" controlId="validationCustom03">
                                    <input
                                        type="tel"
                                        name="phone"
                                        pattern="[0-9]{8,}"
                                        title="Please enter an 8-digit phone number."
                                        className="form-control dashboard-input-box-3"
                                        placeholder="Phone"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a valid phone number.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-12 form-group" controlId="validationCustom04">
                                    <input
                                        type="email"
                                        className="form-control dashboard-input-box-3"
                                        name="email"
                                        placeholder="Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please enter a valid email.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-6 form-group select-box-arrow" controlId="validationCustom05">
                                    <select
                                        className="form-control dashboard-input-box-3"
                                        name="dexterity"
                                        value={dexterity}
                                        onChange={(e) => setDexterity(e.target.value)}
                                        required
                                    >
                                        <option value="">Dexterity</option>
                                        <option value="0">Left</option>
                                        <option value="1">Right</option>
                                    </select>
                                    <BsChevronDown />
                                    <Form.Control.Feedback type="invalid">
                                        Please select dexterity.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="col-md-6 form-group select-box-arrow" controlId="validationCustom06">
                                    <select
                                        className="form-control dashboard-input-box-3"
                                        name="preferredTime"
                                        value={preferredTime}
                                        onChange={(e) => setPreferredTime(e.target.value)}
                                        required
                                    >
                                        <option value="">Preferred Time</option>
                                        <option value="0">Morning</option>
                                        <option value="1">Afternoon</option>
                                        <option value="2">Evening</option>
                                    </select>
                                    <BsChevronDown />
                                    <Form.Control.Feedback type="invalid">
                                        Please select a preferred time.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <div className="col-md-12 form-group">
                                    <textarea
                                        className="form-control dashboard-input-box-3"
                                        name="message"
                                        placeholder="Anything you want us to know?"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        rows={5}
                                        //required
                                    ></textarea>
                                </div>

                                {serverSideError && (
                                    <div className="col-12">
                                        <div style={{ color: "salmon", marginBottom: "10px" }}>
                                            {typeof serverSideError === "string" ? serverSideError : JSON.stringify(serverSideError)}
                                        </div>
                                    </div>
                                )}

                                <div className="col-md-12 text-center">
                                    <Button className="btn btn-dark btn-block form-btn form-btn-request-submit" type="submit" disabled={apicall}>
                                        {apicall ? <Spinner animation="grow" variant="light" /> : <span>Request your fitting</span>}
                                    </Button>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </section>
            <ContactUs />
            <Footer />
            <style>{`
                    section.hero{
                        min-height: 700px !important;
                    }
                    section#our_process{
                        overflow: visible !important;
                    }
                    section#our_process .overflow-visible-container{
                        margin-top: -11rem !important;
                    }
                    .custom-page-img {
                        width: 100% !important;
                        height: 100% !important;
                        object-fit: cover !important;
                    }
                    @media only screen and (min-width: 768px){
                        .hero_content img{
                            max-width: 50vw;
                        }
                    }
                `}</style>
        </>
    );
}

export default Stockdale;
